import { Typography, makeStyles } from "@material-ui/core";
import * as React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  container: {
    textAlign: "center" as "center"
  },
  illustration: {
    display: "block",
    margin: "50px auto",
    maxWidth: "100%",
    position: "relative" as "relative"
  },
  instructionsContainer: {
    display: "inline-block",
    margin: "8px 0",
    maxWidth: "100%",
    position: "relative" as "relative",
    textAlign: "left" as "left",
    width: 164
  },
  message: {
    margin: "0 0 16px"
  }
});

interface IOwnProps {
  message: string;
}

const PageError = ({ message }: IOwnProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <img src="/svgs/error.svg" className={classes.illustration} />
      <Typography className={classes.message} variant="h3">
        {message}
      </Typography>
      <Typography variant="body1">{t("feedback.error.instructions")}</Typography>
      <div className={classes.instructionsContainer}>
        <Typography variant="body1">{t("feedback.error.webAddress")}</Typography>
        <Typography variant="body1">{t("feedback.error.sideNavigation")}</Typography>
        <Typography variant="body1">{t("feedback.error.askSupport")}</Typography>
      </div>
    </div>
  );
};

export default React.memo(PageError);
